export class RequestProgress {
    downloadedBytes: number;
    totalBytes: number;

    constructor(downloadedBytes: number, totalBytes: number) {
        this.downloadedBytes = downloadedBytes;
        this.totalBytes = totalBytes;
    }
}